
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/who-we-are",
      function () {
        return require("private-next-pages/about/who-we-are/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/who-we-are"])
      });
    }
  